// Modulos

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core'; // , LOCALE_ID
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AlertasModales } from './helpers/alertasModales';
import { Helper } from './helpers/helper';
import { SocketIoModule, SocketIoConfig } from 'ng-socket-io';
import { json } from '../assets/data/routemee';

// Thirdparty-modules
import { NgxBarcodeModule } from 'ngx-barcode';
import { TextMaskModule } from 'angular2-text-mask';
import { OnlyNumber } from './onlynumber.directive';
import { NgxMaskModule } from 'ngx-mask';
import { TimeAgoPipe } from 'time-ago-pipe';
import { BrMasker4Module } from 'brmasker4';
import { ImageZoomModule } from 'angular2-image-zoom';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { Ng2DeviceDetectorModule } from 'ng2-device-detector';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
// import localeEs from '@angular/common/locales/es';
// import { registerLocaleData } from '@angular/common';
// registerLocaleData(localeEs);

const production = json.prodEnv;
const config: SocketIoConfig = {
  url: (production ? json.socket : json.dev_socket) , options: {}
};

// Directivas
import { OnlyNumberDirective } from './directivas/onlynumber.directive';

// servicios
import { NgbDateCustomParserFormatter } from './services/ngbDateParserFormatter.service';
import { ClientesService } from './services/Clientes.service';
import { PrestamosService } from './services/prestamos.service';
import { MapService } from './services/map.service';
import { RutasService } from './services/rutas.service';
import { EmpleadosServicio } from './services/empleado.service';
import { AuthGuardService } from './services/auth-guard.service';
import { ClientesReport } from './services/clientes.reports.service';
import { CuadreService } from './services/cuadre.service';
import { ConfiguracionesService } from './services/configuraciones.service';
import { UploadFilesService } from './services/upload-files.service';
import { ReportesService } from './services/reportes.service';
import { ExcelService } from './services/excel.service';

// Componentes
import { AppComponent } from './app.component';
import { LogoutComponent } from './components/logout/logout.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { InicioComponent } from './components/inicio/inicio.component';
import { app_routing } from './app.routes';
import { LoginComponent } from './components/login/login.component';
import { NuevoPrestamoComponent } from './components/prestamos/nuevo/nuevo.component';
import { ListaClientesComponent } from './components/clientes/lista/lista.component';
import { EditarClienteComponent } from './components/clientes/editar/editar.component';
import { ListaCobrosComponent } from './components/cobros/lista/lista.component';
import { NuevoComponent } from './components/cobros/nuevo/nuevo.component';
import { ListaPrestamoComponent } from './components/prestamos/lista/lista.component';
import { AgregarClienteComponent } from './components/clientes/agregar/agregar.component';
import { RutaComponent } from './components/rutas/nueva/ruta.component';
import { ListaRutasComponent } from './components/rutas/lista/lista-rutas.component';
import { NuevoEmpleadoComponent } from './components/empleado/nuevo/nuevo-empleado.component';
import { ListaEmpleadoComponent } from './components/empleado/lista/lista-empleado.component';
import { EmpleadosModalComponent } from './components/modals/lista-empleados/empleados-modal.component';
import { BusquedaAvanzadaComponent } from './components/modals/busqueda-avanzada/busqueda-avanzada.component';
import { DetallePrestamoComponent } from './components/prestamos/detalle/detalle-prestamo/detalle-prestamo.component';
import { DenegarComponent } from './components/modals/denegar/denegar.component';
import { EditarRutaComponent } from './components/modals/editar-ruta/editar-ruta.component';
import { DetalleRutaComponent } from './components/rutas/detalle/detalle-ruta/detalle-ruta.component';
import { Pagina404Component } from './components/pagina-404/pagina-404.component';
import { PerfilClienteComponent } from './components/clientes/perfil/perfil-cliente/perfil-cliente.component';
import { VistaMapaComponent } from './components/modals/vista-mapa/vista-mapa.component';
import { PerfilEmpleadoComponent } from './components/empleado/perfil/perfil-empleado/perfil-empleado.component';
import { ReciboIngresoComponent } from './components/modals/recibo-ingreso/recibo-ingreso.component';
import { SumArrayFieldPipePipe } from './pipes/sum-array-field-pipe.pipe';
import { diferenciaEntreFechas } from './pipes/diferenciaEntreFechas.pipe';
import { AsignarRutasEmpleadoComponent } from './components/modals/asignar-rutas-empleado/asignar-rutas-empleado.component';
import { EditarPrestamoComponent } from './components/prestamos/editar/editar.component';
import { VencidosComponent } from './components/clientes/vencidos/vencidos.component';
import { ProximosAVencerComponent } from './components/clientes/proximos-a-vencer/proximos-a-vencer.component';
import { IncobrablesComponent } from './components/clientes/incobrables/incobrables.component';
import { EditarPassComponent } from './components/modals/editar-pass/editar-pass.component';
import { ConfirmComponent } from './components/modals/confirm/confirm.component';
import { RecibosComponent } from './components/recibos/recibos.component';
import { DetalleComponent } from './components/modals/detalle/detalle.component';
import { ComentarioClienteComponent } from './components/modals/comentario-cliente/comentario-cliente.component';
import { RecordatorioComponent } from './components/modals/recordatorio/recordatorio.component';
import { RecordatoriosComponent } from './components/recordatorios/recordatorios.component';
import { AperturarDiaComponent } from './components/aperturar-dia/aperturar-dia.component';
import { ListaComponent } from './components/aperturar-dia/lista/lista.component';
import { DetalleAperturaComponent } from './components/modals/detalle-apertura/detalle-apertura.component';
import { GastosDiestasComponent } from './components/gastos-diestas/gastos-diestas.component';
import { CerrarDiaComponent } from './components/modals/cerrar-dia/cerrar-dia.component';
import { ProyeccionComponent } from './components/cobros/proyeccion/proyeccion.component';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { CobrosDelDiaComponent } from './components/cobros/cobros-del-dia/cobros-del-dia.component';
import { PromptComponent } from './components/modals/prompt/prompt.component';
import { AgreeComponent } from './components/modals/agree/agree.component';
import { DetalleCierreDiaComponent } from './components/modals/detalle-cierre-dia/detalle-cierre-dia.component';
import { DescuentoCuotaComponent } from './components/modals/descuento-cuota/descuento-cuota.component';
import { PrestamosComponent } from './components/configuraciones/prestamos/prestamos.component';
import { NuevoGastoComponent } from './components/gastos/nuevo/nuevo.component';
import { EditarGastosComponent } from './components/modals/editar-gastos/editar-gastos.component';
import { NotasComponent } from './components/clientes/notas/notas.component';
import { CuotasVencidasComponent } from './components/prestamos/cuotas-vencidas/cuotas-vencidas.component';
import { CuadresFaltanteComponent } from './components/cuadres-faltante/cuadres-faltante.component';
import { RecordatoriosModalComponent } from './components/modals/recordatorios/recordatorios.component';
import { RecorridosComponent } from './components/modals/recorridos/recorridos.component';
import { GastoReporteComponent } from './components/reportes/gasto/gasto.component';
import { ConfiguracionesComponent } from './components/configuraciones/configuraciones.component';
import { OtrasConfiguracionesComponent } from './components/configuraciones/otras-configuraciones/otras-configuraciones.component';
import { AccesoClienteComponent } from './components/modals/acceso-cliente/acceso-cliente.component';
import { NgDropFilesDirective } from './directivas/ng-drop-files.directive';
import { ReporteGlobalSemanalComponent } from './components/reportes/reporte-global-semanal/reporte-global-semanal.component';
import { PreguntasSecretasComponent } from './components/modals/preguntas-secretas/preguntas-secretas.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { RestablecerContrasenaComponent } from './components/modals/restablecer-contrasena/restablecer-contrasena.component';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';
import { DynamicFormQuestionComponent } from './components/dynamic-form/dynamic-form-question.component';
import { PadronService } from './services/padron.service';
import { TitleCasePipe } from './pipes/title-case.pipe';
import { CartasPdfComponent } from './components/modals/cartas-pdf/cartas-pdf.component';
import { RetabilidadRutaComponent } from './components/reportes/retabilidad-ruta/retabilidad-ruta.component';
import { NotaCreditoCuotasComponent } from './components/nota-credito-cuotas/nota-credito-cuotas.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { CartaComponent } from './components/configuraciones/carta/carta.component';
import { PagareNotarialComponent } from './components/configuraciones/pagare-notarial/pagare-notarial.component';
import { PagareNotarialModalComponent } from './components/modals/pagare-notarial-modal/pagare-notarial-modal.component';
import { ControlCobrosComponent } from './components/reportes/control-cobros/control-cobros.component';
import { EditarAperturaComponent } from './components/modals/editar-apertura/editar-apertura.component';
import { DataCreditoComponent } from './components/reportes/data-credito/data-credito.component';
// tslint:disable-next-line:max-line-length
import { RecuperarClienteDatacreditoComponent } from './components/modals/recuperar-cliente-datacredito/recuperar-cliente-datacredito.component';
import { CuentasPorCobrarComponent } from './components/reportes/cuentas-por-cobrar/cuentas-por-cobrar.component';
import { ActividadesComponent } from './components/actividades/actividades.component';
import { EditarEmpleadoComponent } from './components/empleado/editar-empleado/editar-empleado.component';
import { PausarMoraComponent } from './components/modals/pausar-mora/pausar-mora.component';
import { AtrasosPorRutaComponent } from './components/reportes/atrasos-por-ruta/atrasos-por-ruta.component';
import { PresolicitudesComponent } from './components/presolicitudes/presolicitudes.component';
import { CartaSaldoComponent } from './components/configuraciones/carta-saldo/carta-saldo.component';
import { CartaSaldoModalComponent } from './components/modals/carta-saldo/carta-saldo.component';
import { DetalleNotaCreditoComponent } from './components/modals/detalle-nota-credito/detalle-nota-credito.component';
import { GlobalDiarioComponent } from './components/reportes/global-diario/global-diario.component';
import { TimingComponent } from './components/modals/timing/timing.component';
import { AsignarCompaniaEmpleadoComponent } from './components/modals/asignar-compania-empleado/asignar-compania-empleado.component';
import { NotasClienteComponent } from './components/modals/notas-cliente/notas-cliente.component';
import { HistorialPagoPrestamoComponent } from './components/modals/historial-pago-prestamo/historial-pago-prestamo.component';
import { CompaniaComponent } from './components/configuraciones/compania/compania.component';
import { ProyeccionDetalleComponent } from './components/cobros/proyeccion-detalle/proyeccion-detalle.component';
import { ImportarClientesRutaComponent } from './components/modals/importar-clientes-ruta/importar-clientes-ruta.component';
import { AnticiposComponent } from './components/reportes/anticipos/anticipos.component';
import { DineroEntregadoComponent } from './components/reportes/dinero-entregado/dinero-entregado.component';
// tslint:disable-next-line:max-line-length
import { PrestamosSaldaronNoRenovaronComponent } from './components/reportes/prestamos-saldaron-no-renovaron/prestamos-saldaron-no-renovaron.component';
import { PorZonaComponent } from './components/cobros/por-zona/por-zona.component';
import { AsignarPaginaComponent } from './components/modals/asignar-pagina/asignar-pagina.component';
import { AsignarPermisoComponent } from './components/modals/asignar-permiso/asignar-permiso.component';
import { RegionesService } from './services/regiones.service';
import { RegionesComponent } from './components/regiones/regiones.component';
import { RegionComponent } from './components/modals/region/region.component';
import { SubregionComponent } from './components/modals/subregion/subregion.component';
import { AgregarPresolicitudComponent } from './components/presolicitudes/agregar-presolicitud/agregar-presolicitud.component';
import { SeleccionarEmpleadoComponent } from './components/modals/seleccionar-empleado/seleccionar-empleado.component';
import { SemanalComponent } from './components/reportes/semanal/semanal.component';
import { DetalleSolicitudComponent } from './components/modals/detalle-solicitud/detalle-solicitud.component';
import { EditarSolicitudComponent } from './components/editar-solicitud/editar-solicitud.component';
import { ReporteSemanalEmpresasComponent } from './components/reportes/reporte-semanal-empresas/reporte-semanal-empresas.component';
import { CompaniasService } from './services/companias.service';
import { Semanal2Component } from './components/reportes/semanal-2/semanal-2.component';
import { VerFotosClienteComponent } from './components/modals/ver-fotos-cliente/ver-fotos-cliente.component';
import { Date2Pipe } from './pipes/date2.pipe';
import { HistorialTelefonoComponent } from './components/modals/historial-telefono/historial-telefono.component';
import { RegistrarSolicitudComponent } from './share/registrar-solicitud/registrar-solicitud.component';
import { SolicitarPrestamoComponent } from './pages/solicitar-prestamo/solicitar-prestamo.component';
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { TokenComponent } from './components/modals/token/token.component';
import { RespaldarComponent } from './components/respaldar/respaldar.component';
import { CobradoresTrabajandoComponent } from './components/cobradores-trabajando/cobradores-trabajando.component';
import { ReporteConsolidadoPorCiudadComponent } from './components/reportes/reporte-consolidado-por-ciudad/reporte-consolidado-por-ciudad.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    HeaderComponent,
    FooterComponent,
    InicioComponent,
    LoginComponent,
    NuevoPrestamoComponent,
    ListaClientesComponent,
    EditarClienteComponent,
    ListaCobrosComponent,
    ListaPrestamoComponent,
    AgregarClienteComponent,
    LogoutComponent,
    RutaComponent,
    ListaRutasComponent,
    NuevoEmpleadoComponent,
    ListaEmpleadoComponent,
    EmpleadosModalComponent,
    NuevoComponent,
    BusquedaAvanzadaComponent,
    DetallePrestamoComponent,
    DenegarComponent,
    OnlyNumberDirective,
    EditarRutaComponent,
    DetalleRutaComponent,
    Pagina404Component,
    PerfilClienteComponent,
    VistaMapaComponent,
    PerfilEmpleadoComponent,
    ReciboIngresoComponent,
    SumArrayFieldPipePipe,
    diferenciaEntreFechas,
    AsignarRutasEmpleadoComponent,
    EditarPrestamoComponent,
    VencidosComponent,
    ProximosAVencerComponent,
    IncobrablesComponent,
    EditarPassComponent,
    ConfirmComponent,
    RecibosComponent,
    DetalleComponent,
    ComentarioClienteComponent,
    RecordatorioComponent,
    RecordatoriosComponent,
    AperturarDiaComponent,
    ListaComponent,
    DetalleAperturaComponent,
    GastosDiestasComponent,
    CerrarDiaComponent,
    CobrosDelDiaComponent,
    OnlyNumber,
    ProyeccionComponent,
    CobrosDelDiaComponent,
    TimeAgoPipe,
    PromptComponent,
    AgreeComponent,
    DetalleCierreDiaComponent,
    DescuentoCuotaComponent,
    PrestamosComponent,
    NuevoGastoComponent,
    EditarGastosComponent,
    NotasComponent,
    CuotasVencidasComponent,
    CuadresFaltanteComponent,
    RecordatoriosModalComponent,
    RecorridosComponent,
    GastoReporteComponent,
    ConfiguracionesComponent,
    OtrasConfiguracionesComponent,
    AccesoClienteComponent,
    NgDropFilesDirective,
    ReporteGlobalSemanalComponent,
    PreguntasSecretasComponent,
    ForgotPasswordComponent,
    RestablecerContrasenaComponent,
    DynamicFormComponent,
    DynamicFormQuestionComponent,
    TitleCasePipe,
    CartasPdfComponent,
    RetabilidadRutaComponent,
    NotaCreditoCuotasComponent,
    SafeHtmlPipe,
    CartaComponent,
    PagareNotarialComponent,
    PagareNotarialModalComponent,
    ControlCobrosComponent,
    EditarAperturaComponent,
    DataCreditoComponent,
    RecuperarClienteDatacreditoComponent,
    CuentasPorCobrarComponent,
    ActividadesComponent,
    EditarEmpleadoComponent,
    PausarMoraComponent,
    AtrasosPorRutaComponent,
    PresolicitudesComponent,
    CartaSaldoComponent,
    CartaSaldoModalComponent,
    DetalleNotaCreditoComponent,
    GlobalDiarioComponent,
    TimingComponent,
    AsignarCompaniaEmpleadoComponent,
    NotasClienteComponent,
    HistorialPagoPrestamoComponent,
    CompaniaComponent,
    ProyeccionDetalleComponent,
    ImportarClientesRutaComponent,
    AnticiposComponent,
    DineroEntregadoComponent,
    PrestamosSaldaronNoRenovaronComponent,
    PorZonaComponent,
    AsignarPaginaComponent,
    AsignarPermisoComponent,
    RegionesComponent,
    RegionComponent,
    SubregionComponent,
    AgregarPresolicitudComponent,
    SeleccionarEmpleadoComponent,
    SemanalComponent,
    DetalleSolicitudComponent,
    EditarSolicitudComponent,
    ReporteSemanalEmpresasComponent,
    Semanal2Component,
    VerFotosClienteComponent,
    Date2Pipe,
    HistorialTelefonoComponent,
    RegistrarSolicitudComponent,
    SolicitarPrestamoComponent,
    TokenComponent,
    RespaldarComponent,
    CobradoresTrabajandoComponent,
    ReporteConsolidadoPorCiudadComponent
  ],
  imports: [
    BrowserModule,
    app_routing,
    FormsModule,
    RecaptchaModule,
    ReactiveFormsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAMhP_E1xqUTY3mO6W-D9OcleA5uQWVqbU',
      libraries: ['places']
    }),
    HttpClientModule,
    SocketIoModule.forRoot(config),
    NgbModule.forRoot(),
    NgxBarcodeModule,
    TextMaskModule,
    NgxMaskModule.forRoot(),
    MyDateRangePickerModule,
    TextMaskModule,
    BrMasker4Module,
    CurrencyMaskModule,
    ImageZoomModule,
    Ng2DeviceDetectorModule.forRoot(),
    AngularMultiSelectModule,
    AgmSnazzyInfoWindowModule
    ],
  providers: [
    ClientesService,
    PrestamosService,
    MapService,
    RutasService,
    AlertasModales,
    EmpleadosServicio,
    Helper,
    AuthGuardService,
    ClientesReport,
    CuadreService,
    ConfiguracionesService,
    UploadFilesService,
    {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter},
    { provide: RECAPTCHA_SETTINGS, useValue: { siteKey: '6LeJB_8UAAAAAN1OWQ62oASxeErk4pYTG90ecEt4' } as RecaptchaSettings},
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'es',
    },
    PadronService,
    ReportesService,
    ExcelService,
    RegionesService,
    CompaniasService,
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    TokenComponent,
    EmpleadosModalComponent,
    BusquedaAvanzadaComponent,
    DenegarComponent,
    EditarRutaComponent,
    VistaMapaComponent,
    ReciboIngresoComponent,
    AsignarRutasEmpleadoComponent,
    EditarPassComponent,
    ConfirmComponent,
    DetalleComponent,
    ComentarioClienteComponent,
    RecordatorioComponent,
    DetalleAperturaComponent,
    CerrarDiaComponent,
    PromptComponent,
    AgreeComponent,
    DetalleCierreDiaComponent,
    DescuentoCuotaComponent,
    EditarGastosComponent,
    RecordatoriosModalComponent,
    RecorridosComponent,
    AccesoClienteComponent,
    PreguntasSecretasComponent,
    RestablecerContrasenaComponent,
    CartasPdfComponent,
    PagareNotarialModalComponent,
    EditarAperturaComponent,
    RecuperarClienteDatacreditoComponent,
    PausarMoraComponent,
    CartaSaldoComponent,
    CartaSaldoModalComponent,
    DetalleNotaCreditoComponent,
    TimingComponent,
    AsignarCompaniaEmpleadoComponent,
    NotasClienteComponent,
    HistorialPagoPrestamoComponent,
    ImportarClientesRutaComponent,
    AsignarPaginaComponent,
    AsignarPermisoComponent,
    SeleccionarEmpleadoComponent,
    DetalleSolicitudComponent,
    RegionComponent,
    SubregionComponent,
    SeleccionarEmpleadoComponent,
    VerFotosClienteComponent,
    HistorialTelefonoComponent
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/app.module.ts